import React from 'react';
export function AnaNutricionistaLogo({
  size = 48
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0" data-id="element-51">
      {/* Background circle */}
      <circle cx="50" cy="50" r="50" fill="url(#gradient)" data-id="element-52" />

      {/* Leaf icon */}
      <path d="M50 25C50 25 35 30 35 45C35 55 42 62 50 65C58 62 65 55 65 45C65 30 50 25 50 25Z" fill="white" opacity="0.9" data-id="element-53" />
      <path d="M50 25C50 25 50 40 50 65" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.6" data-id="element-54" />

      {/* Text "AN" */}
      <text x="50" y="85" fontSize="24" fontWeight="bold" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif" data-id="element-55">
        AN
      </text>

      {/* Gradient definition */}
      <defs data-id="element-56">
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-57">
          <stop offset="0%" stopColor="#10B981" data-id="element-58" />
          <stop offset="100%" stopColor="#059669" data-id="element-59" />
        </linearGradient>
      </defs>
    </svg>;
}